import React, { useState } from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { MultiSelectCheckbox } from '../../ui';
import { Form } from '../../../store/form/types';
import { FormTypeEnum } from '../../../store/form/types.d';
import { useTranslation } from 'react-i18next';
import { PaperStatus } from '../../../store/paper-status/types';
import { isDefaultSubmissionForm } from '../../../helpers/form';

interface Props extends Omit<SimpleDialogProps, 'handleOk'> {
  paperStatus: PaperStatus;
  formById: { [key: number]: Form };
  handleOk: (formIds: number[]) => void;
}

const PaperStatusFormDialog: React.FC<Props> = ({ paperStatus, formById, handleOk, ...rest }) => {
  const { t, i18n } = useTranslation();
  const [formIds, setFormIds] = useState<string[]>(() =>
    Object.values(formById)
      .filter((form) => form.paper_status_ids.includes(paperStatus.id))
      .map((form) => form.id.toString()),
  );

  const options = Object.values(formById)
    .filter((form) => !isDefaultSubmissionForm(form) && form.type == FormTypeEnum.Submission)
    .map((form) => {
      return { id: form.id.toString(), label: form.name };
    });

  return (
    <SimpleDialog
      {...rest}
      open={true}
      handleOk={options.length > 0 ? () => handleOk(formIds.map((formId) => parseInt(formId))) : undefined}
      title={t('Visibility in {{name}} status', { name: paperStatus.name })}
    >
      {options.length > 0 ? (
        <>
          <p className="mb-3">{t(`Please select which forms are subjected to this paper status`)}</p>
          <MultiSelectCheckbox
            options={options}
            value={formIds}
            onChange={(value) => setFormIds(value)}
            className="flex flex-col gap-y-2"
          />
        </>
      ) : (
        <p>{t('No available forms')}</p>
      )}
    </SimpleDialog>
  );
};

export default PaperStatusFormDialog;
